import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/notifications/page.tsx");
